import { render, staticRenderFns } from "./ShopPresetCustomField.vue?vue&type=template&id=08e50c78"
import script from "./ShopPresetCustomField.vue?vue&type=script&lang=js"
export * from "./ShopPresetCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports